<template>
  <div module-item class="media" :class="info.type">
    <ul>
      <li v-for="(row, i) in info.value" :key="i">
        <cdn-img :src="row.pc" class="hidden-tp-down" v-if="matchMediaType(row.pc, 'image')"/>
        <cdn-video :src="row.pc" loop autoplay muted playsinline class="hidden-tp-down" v-if="matchMediaType(row.pc, 'video')"/>
        <cdn-img :src="row.mobile" class="hidden-tl-up" v-if="matchMediaType(row.mobile, 'image')"/>
        <cdn-video :src="row.mobile" loop autoplay muted playsinline class="hidden-tl-up" v-if="matchMediaType(row.mobile, 'video')"/>
      </li>
    </ul>
  </div>
</template>

<script>

import CdnImg from '@/views/components/CdnImg.vue';
import CdnVideo from '@/views/components/CdnVideo.vue';

export default {
  name: 'Media',
  components: { CdnVideo, CdnImg },
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
};
</script>

